import React, { useEffect, useState, useRef } from 'react';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import { Button, Modal, Radio, Checkbox } from 'antd';
import { GET_DMT_TRANS_REPORT, POST_DMT_FAIL_TRANSACTION, POST_DMT_REINITIATE_TRANSACTION, POST_FINO_TRANSACTION_ENQUIRY, POST_DMT_INSTANT_PAY_RE_INITIATE_TRANSACTION, POST_FINO_SEND_REFUND_OTP, POST_FINO_CLAIM_REFUND /* POST_DMT_INSTANT_PAY_TRANSACTION_INQUIRY, POST_DMT_PAY_SPRINT_TRANSACTION_INQUIRY */ } from './../../../Utils/appConstants';
import { dmtStatus, dmtStatusExport, dmtDetailStatus, dmtStatusInArray, dmtModeInArray, channelStatus, finoStatus, finoDetailStatus } from './../../../Utils/Common';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
// import PropagateLoader from "react-spinners/PropagateLoader";
import { DatePicker, Tooltip, Table, Space, Tag, Select } from 'antd';
import { getUTCToLocalDateTimeFormat, toDayDate, queryDate, getExportFormat } from '../../../Utils/function';
// import './styles.css'; // Assuming you have a CSS file for styling
import { isNumber, isAlphabetOnly } from '../../../Utils/Common';

function FinoHistoryReport(props) {
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';
    const [searchUserId, setSearchUserId] = useState(null);
    const [searchAccountNumber, setSearchAccountNumber] = useState(null);
    const [searchTransId, setSearchTransId] = useState(null);
    const [searchCustomerId, setSearchCustomerId] = useState(null);
    const [searchStatus, setSearchStatus] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(toDayDate());
    const [startDate, setStartDate] = useState(toDayDate());
    const [getData, setData] = useState([]);
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [searchMode, setSearchMode] = useState(null);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);
    const [userId, setUserId] = useState(props.userId);
    const [isChecked, setChecked] = useState([]);
    const [showOTPInput, setShowOTPInput] = useState(false);
    const [otp, setOtp] = useState('');
    const [currentTransaction, setCurrentTransaction] = useState(null);
    const [isOtpTransactionModal, setOtpTransactionModal] = useState(false);
    const [referenceCode, setReferenceCode] = useState('');
    const [referenceid, setReferenceId] = useState('');
    const [ackno, setAckno] = useState('');
    const [merchantcode, setMerchantcode] = useState('');

    const onChangeOtpValue = (value) => {
        setOtp(value);
    }

    const onClick = (event) => {
        let { checked, value } = event.target;
        if (checked) {
            setChecked([...isChecked, value]);
        } else {
            const updatedArray = isChecked.filter(item => item !== value);
            setChecked(updatedArray);
        }
    };

    const columns = [{
        name: 'Date Time',
        cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
        width: "200px",
    }, {
        name: 'Trans ID',
        selector: row => <Tooltip placement="bottom" title={row.client_ref_id && row.client_ref_id}>{row.client_ref_id && row.client_ref_id}</Tooltip>,
        width: "180px",
    }, {
        name: 'Amount',
        selector: row => row.amount + ' ' + row.currency,
        width: "100px",
    }, {
        name: 'Status',
        selector: row => dmtStatus(row.txtStatus),
        width: "150px",
    },
    // {
    //     name: 'Action',
    //     selector: row => row.txtStatus === 7 && <button type="button" className='btn btn-sm border border-dark text-dark' onClick={() => handleSubmit(row)} title='Refund'><i className="fas fa-sync"></i> Refund</button>,
    //     width: "140px",
    // }, 
    {
        name: 'Mode',
        selector: row => channelStatus(row.channel),
    }, {
        name: 'Customer ID',
        selector: row => <Tooltip placement="bottom" title={row.customer_id}>{row.customer_id}</Tooltip>,
        width: "130px",
    }, {
        name: 'Partner ID',
        selector: row => <Tooltip placement="bottom" title={row.users && row.users.username}>{row.users && row.users.username}</Tooltip>,
        width: "130px",
    }, {
        name: 'Bank Name',
        selector: row => (row.baneData && row.baneData.bankName) || (row.baneData1 && row.baneData1.bankName),
        width: "220px",
    }, {
        name: 'IFSC Code',
        selector: row => row.ifsccode,
        width: "120px",
    }, {
        name: 'Account Number',
        selector: row => row.accountNumber,
        width: "170px",
    }, {
        name: 'Bene Name',
        selector: row => row.baneData ? row.baneData.beneName : (row.baneData1) ? row.baneData1.beneName : "",
        width: "190px",
    },
    {
        name: 'Bank RRN',
        selector: row =>
            row?.dmttransactiondetails?.length > 0
                ? row.dmttransactiondetails[0]?.bank_ref_num || ""
                : "",
        width: "190px",
    },
    {
        name: 'Message',
        selector: row => <Tooltip placement="bottom" title={row.message && row.message}>{row.message && row.message}</Tooltip>,
        width: "200px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };   // removed partial line here
        },
    }];

    const handleSubmit = (data) => {
        setLoading(true);
        setCurrentTransaction(data);

        const payload = {
            merchantcode: data.users.username.replace('AY', 'FI'),
            referenceid: data.client_ref_id,
            ackno: data.dmttransactiondetails[0].tid
        };
        let URL = POST_FINO_SEND_REFUND_OTP;
        postRequest(`${URL}`, payload, history).then((response) => {

            console.log("response", response);
            if (response.success === true) {
                toast.success(response.message);


                setOtp(null);

                setReferenceId(data.client_ref_id);
                setAckno(data.dmttransactiondetails[0].tid);
                setMerchantcode(data.users.username.replace('AY', 'FI'));
                setReferenceCode(response?.data?.stateresp);


                setOtpTransactionModal(true);


                // setShowOTPInput(true); // Show OTP input box on success
                // getDataReports();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            toast.error('An error occurred while requesting OTP');
        });
    };

    const handleOTPCancel = () => {
        setOtpTransactionModal(false);
        setOtp('');
        setCurrentTransaction(null);
    };


    const handleOTPSubmit = (data) => {
        setLoading(true);
        setCurrentTransaction(data);
        const payload = {
            merchantcode: merchantcode,
            referenceid: referenceid,
            ackno: ackno,
            otp: otp,
            stateresp: referenceCode
        };
        let URL = POST_FINO_CLAIM_REFUND;


        postRequest(`${URL}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);


                setLoading(false);
                setOtpTransactionModal(false);
                setOtp('');
                setCurrentTransaction(null);
                toast.success('Refund processed successfully');
                getDataReports();


                // setShowOTPInput(true); // Show OTP input box on success
                // getDataReports();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            toast.error('An error occurred while requesting OTP');
        });
    };


    const failTransaction = () => {
        if (isChecked.length > 0) {
            postRequest(`${POST_DMT_FAIL_TRANSACTION}`, isChecked, history).then((response) => {
                if (response.success === true) {
                    getDataReports();
                    toast.success(response.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        } else {
            toast.error("Minimum one record is selected");
        }
    };

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        setLoading(true);
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
        }
        if (endDate) {
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        if (props.userId) {
            params.userId = userId ? userId : props.userId;
        }

        params.reportType = 'fino';

        params.searchAccountNumber = searchAccountNumber ? searchAccountNumber : '';
        params.searchCustomerId = searchCustomerId ? searchCustomerId : '';
        params.searchTransId = searchTransId ? searchTransId : '';
        params.searchUserId = searchUserId ? searchUserId : '';
        params.searchStatus = searchStatus ? searchStatus : '';
        params.searchMode = searchMode ? searchMode : '';

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANS_REPORT}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });
    };

    const getCSVDataList = () => {
        let params = {};
        params.exportsCsv = true;
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        if (props.userId) {
            params.userId = userId ? userId : props.userId;
        }
        params.reportType = 'fino';
        params.searchAccountNumber = searchAccountNumber ? searchAccountNumber : '';
        params.searchCustomerId = searchCustomerId ? searchCustomerId : '';
        params.searchTransId = searchTransId ? searchTransId : '';
        params.searchUserId = searchUserId ? searchUserId : '';
        params.searchStatus = searchStatus ? searchStatus : '';
        params.searchMode = searchMode ? searchMode : '';

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANS_REPORT}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                let csvdataRecord = [];
                let csvdata = response.data;
                csvdata.map((e) => {
                    return csvdataRecord.push({
                        "Date Time": getExportFormat(e.createdAt),
                        "Trans ID": e.client_ref_id,
                        "Amount": e.amount,
                        "Status": dmtStatusExport(e.txtStatus),
                        "Mode": channelStatus(e.channel),
                        "Customer Id": e.customer_id,
                        "Partner Id": e.users && e.users.username,
                        "Bank Name": (e.baneData && e.baneData.bankName) || (e.baneData1 && e.baneData1.bankName),
                        "IFSC Code": e.ifsccode,
                        "Account Number": e.accountNumber,
                        "Bene Name": e.baneData ? e.baneData.beneName : (e.baneData1) ? e.baneData1.beneName : "",
                        "Message": e.message,
                    });
                });
                setCsvData(csvdataRecord);
                setTimeout(() => {
                    csvLink.current.link.click();
                }, 1000);
            } else {
                setCsvData([]);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    const handlePageChange = (page, size) => {
        setPage(page);
    };

    const onChangeStartDate = (date, dateString) => {
        setStartDate(date);
    };

    const onChangeEndDate = (date, dateString) => {
        setEndDate(date);
    };

    const handleSearch = () => {
        getDataReports();
    };

    const transactionInquiry = (data) => {
        setLoading(true);
        const payload = { transactionId: data.transactionId };
        let URL = POST_FINO_TRANSACTION_ENQUIRY;
        postRequest(`${URL}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                getDataReports();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
        });
    };

    const onChangeType = (value) => {
        setSearchStatus(value);
    };

    const onChangeTypeMode = (value) => {
        setSearchMode(value);
    };

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setSearchUserId('');
    };

    useEffect(() => {
        if (props.userId) {
            setUserId(props.userId);
        }
        getDataReports();
    }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

    const ExpandableComponent = (props, key) => (
        <div className='ml-5 w-50'>
            <Table
                dataSource={props.data.dmttransactiondetails}
                key={key}
                columns={[
                    {
                        title: "#",
                        render: (record, key) => (
                            <input
                                type="checkbox"
                                className="pointer"
                                onChange={(e) => onClick(e)}
                                checked={isChecked.includes(record._id)}
                                disabled={record.isInsufficientFund && (record.tx_status === null || record.tx_status === "-1") ? false : true}
                                value={record._id}
                            />
                        ),
                    },
                    {
                        title: 'Transaction Id',
                        dataIndex: 'transactionId',
                        key: 'transactionId',
                    },
                    {
                        title: 'Amount',
                        dataIndex: 'amount',
                        key: 'amount',
                    },
                    {
                        title: 'Bank RRN',
                        dataIndex: 'bank_ref_num',
                        key: 'bank_ref_num',
                    },
                    {
                        title: 'Status',
                        key: 'txstatus_desc',
                        render: (record, key) => (
                            <Space key={key} size="middle">{dmtDetailStatus(record.tx_status)}</Space>
                        ),
                    },
                    {
                        title: "Action",
                        key: "action",
                        render: (record, key) => (
                            <><Space key={key} size="middle">
                                {!record.isRefund && (record.tx_status === "0" || record.tx_status === "1" || record.tx_status === "2" || record.tx_status === "3" || record.tx_status === "5" || record.tx_status === "7") && <Tag color={"yellow"} onClick={() => transactionInquiry(record)} className='pointer' key={0}>
                                    INQUIRY
                                </Tag>}
                            </Space></>
                        )
                    },
                    {
                        title: 'Message',
                        dataIndex: 'reason',
                        key: 'reason',
                    },
                ]}
            />
        </div>
    );

    // if (isLoading) {
    //     return <div className="content text-center" style={{ margin: "250px 0" }}>
    //         <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
    //     </div>
    // }

    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-center">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>FINO Transfer <span className='text-red'>Report</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid pt-2 pb-5">
                        <div className="row">
                            <div className='card col-md-12 py-3'>
                                <div className='card-body p-0'>
                                    <div className="row">
                                        <div className='col-md-12 date-search mb-0'>
                                            <div className='row'>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-blue'>From</label>
                                                        <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={onChangeStartDate} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'>To</label>
                                                        <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={onChangeEndDate} />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="User ID" onChange={(e) => setSearchUserId(e.target.value)} value={searchUserId} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="Trans ID" onChange={(e) => setSearchTransId(e.target.value)} value={searchTransId} />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group mr-3">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="A/C Number" onChange={(e) => setSearchAccountNumber(e.target.value)} value={searchAccountNumber} />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className='date-search-label mb-0 text-red'></label>
                                                        <input type="text" className="form-control form-control-border" placeholder="Customer ID" onChange={(e) => setSearchCustomerId(e.target.value)} value={searchCustomerId} />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 col-lg-3 d-flex'>
                                                    <div className="form-group col-6">
                                                        <label className='date-search-label mb-0 text-red'>&nbsp;</label>
                                                        <Select options={dmtModeInArray} className={`normal-light w-100`} classNamePrefix="select" placeholder="-- Mode --" name='mode' onChange={(e) => onChangeTypeMode(e)} />
                                                    </div>
                                                    <div className="form-group col-6">
                                                        <label className='date-search-label mb-0 text-red'>&nbsp;</label>
                                                        <Select mode="multiple" options={dmtStatusInArray} className={`normal-light w-100`} classNamePrefix="select" placeholder="-- Status --" name='status' onChange={(e) => onChangeType(e)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CSVLink
                                        data={getCsvData}
                                        filename='money-transfer-report'
                                        className='hidden'
                                        ref={csvLink}
                                        target='_blank'
                                    />
                                    <div className="container-fluid pt-2 pb-5">
                                        <DataTable
                                            title={""}
                                            columns={columns}
                                            data={getData.docs}
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            expandableRows
                                            actions={
                                                <>
                                                    <button type="submit" className="btn btn-primary rounded-pill px-3" onClick={() => handleSearch()}>Search</button>
                                                    <button type="submit" className="btn btn-default rounded-pill px-4" onClick={() => handleClear()}>Clear</button>
                                                    <button type="button" className="btn btn-primary mr-3" onClick={() => getCSVDataList()}><i className="fa fa-file-excel"></i> Export</button>
                                                    <button disabled={isChecked.length > 0 ? false : true} onClick={() => failTransaction()} className='btn btn-danger btn-sm'>Fail Transaction</button>
                                                </>
                                            }
                                            expandableRowExpanded={row => row.index}
                                            progressPending={isLoading}
                                            expandableRowsComponent={ExpandableComponent}
                                            paginationTotalRows={getTotalRecord}
                                            onChangeRowsPerPage={getDataReports}
                                            onChangePage={handlePageChange}
                                        />
                                    </div>
                                    {showOTPInput && (
                                        <div className="otp-modal">
                                            <div className="otp-modal-content">
                                                <h3>Enter OTP</h3>
                                                <input
                                                    type="text"
                                                    value={otp}
                                                    onChange={(e) => setOtp(e.target.value)}
                                                    placeholder="Enter OTP"
                                                    className="otp-input"
                                                    maxLength="6"
                                                />
                                                <div className="otp-buttons">
                                                    <button
                                                        onClick={handleOTPCancel}
                                                        classnanme="cancel-button"
                                                        disabled={isLoading}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={handleOTPSubmit}
                                                        className="submit-button"
                                                        disabled={isLoading || otp.length < 6}
                                                    >
                                                        {isLoading ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isOtpTransactionModal && <Modal title={"Refund OTP Verification"} width={600} open={isOtpTransactionModal} footer={false} >

                <div className="form-group pt-5">
                    <label>OTP Code</label>
                    <div className="input-group">
                        <div className="custom-file">
                            <input type="text" className="form-control" name="otpCode" placeholder="OTP Code" onChange={(e) => onChangeOtpValue(e.target.value)} autoComplete="off" value={otp} maxLength={6} onKeyDown={isNumber} />
                        </div>
                    </div>
                </div>
                <div className="form-group pt-2 text-right">
                    <button type='button' className='btn btn-default pointer mr-2' onClick={() => handleOTPCancel()} >Cancel</button>
                    <button type='button' className='btn btn-primary pointer' onClick={() => handleOTPSubmit()}>Submit</button>
                </div>
            </Modal>}
        </div>

    );
}

export default FinoHistoryReport;